import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login = _resolveComponent("login")!
  const _component_send_code = _resolveComponent("send-code")!
  const _component_confirm = _resolveComponent("confirm")!
  const _component_esia_error = _resolveComponent("esia-error")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.state.isLogin())
      ? (_openBlock(), _createBlock(_component_login, {
          key: 0,
          modelValue: $data.authModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.authModel) = $event)),
          service: $data.service,
          onNext: $options.onLoginNext
        }, null, 8 /* PROPS */, ["modelValue", "service", "onNext"]))
      : _createCommentVNode("v-if", true),
    ($data.state.isSendCode())
      ? (_openBlock(), _createBlock(_component_send_code, {
          key: 1,
          modelValue: $data.authModel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.authModel) = $event)),
          service: $data.service,
          "on-next": $options.onSendCodeNext,
          onBack: $options.onSendCodeBack
        }, null, 8 /* PROPS */, ["modelValue", "service", "on-next", "onBack"]))
      : _createCommentVNode("v-if", true),
    ($data.state.isConfirm())
      ? (_openBlock(), _createBlock(_component_confirm, {
          key: 2,
          modelValue: $data.authModel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.authModel) = $event)),
          service: $data.service,
          "on-next": $options.onConfirmSend,
          onCancel: $options.onCancel
        }, null, 8 /* PROPS */, ["modelValue", "service", "on-next", "onCancel"]))
      : _createCommentVNode("v-if", true),
    ($data.state.isEsiaError())
      ? (_openBlock(), _createBlock(_component_esia_error, {
          key: 3,
          service: $data.service,
          onBack: $options.onCancel
        }, null, 8 /* PROPS */, ["service", "onBack"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}